import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

/**
 * Prevents a billing-config outage from downgrading signup to an unmetered organization.
 *
 * @returns A recoverable, blocking signup-configuration error.
 */
export const SignupConfigLoadError = () => (
  <div className="mx-auto mt-16 max-w-xl px-6">
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>
        Unable to load signup configuration. Refresh the page to try again.
      </AlertDescription>
    </Alert>
  </div>
);
